<template>
  <v-content>
    <v-card width="400" class="mx-auto mt-5">
      <v-card-title>
        <h1 class="title">Change Email</h1>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-text-field
            v-model="email"
            label="E-Mail"
            required
            prepend-icon="mdi-email"
            type="text"
            :rules="emailRules"
            :counter="100"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mx-0 my-2" text to="/">Cancel</v-btn>
        <v-btn class="mx-4 my-2" color="primary" @click="submit" :loading="loading">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-content>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { dataService, validationMixin, errorMessageMixin } from "../shared";

export default {
  name: "Email",
  props: {
    adminParam: {
      type: String,
      default: ""
    }
  },
  mixins: [validationMixin, errorMessageMixin],
  computed: {
    ...mapState(["account"])
  },
  data: () => ({
    loading: false,
    email: ""
  }),
  methods: {
    ...mapActions(["updateAccountEmailAction"]),
    async submit() {
      this.$store.state.snackbar = false;
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          console.log("check duplicate for", this.email);
          var validEmail = await dataService.checkEmail(this.email);
          if (!validEmail) {
            this.$store.state.error = "Email already used by another account.";
            this.$store.state.snackbar = true;
          } else {
            // save this email update.
            console.log("im a good email");
            try {
              let accountId = 0;
              if (this.adminParam === "admin") {
                accountId = this.$store.state.user.id;
              } else {
                accountId = this.account.id;
              }
              console.log("accountId", accountId);

              let emailModel = {
                accountId: accountId,
                email: this.email
              };
              await this.updateAccountEmailAction({
                model: emailModel,
                token: this.$store.state.token
              });
              console.log("go home");
              this.$router.push({
                name: "Home",
                params: { msg: this.adminParam + " Account updated." }
              });
            } catch (err) {
              this.$store.state.error = this.errorMessage(err);
              this.$store.state.snackbar = true;
              console.log(err);
            }
          }
        } catch (err) {
          this.$store.state.error = this.errorMessage(err);
          this.$store.state.snackbar = true;
          console.log(err);
        }
        this.loading = false;
      }
    }
  }
};
</script>